import React from "react";
import { FaRegClock, FaShippingFast, FaMoneyCheckAlt } from "react-icons/fa"; // React Icons

const features = [
  {
    icon: <FaRegClock size={32} className="text-orange-500" />,
    title: "Sadece 1 Dakikada Teklif Al",
    description: "Formumuzu doldur, ön fiyat teklifini hemen al.",
  },
  {
    icon: <FaShippingFast size={32} className="text-blue-500" />,
    title: "Teslimat Tercihini Belirle",
    description:
      "Kapında sat hizmeti ya da kargo ile telefonunu bize ücretsiz gönderebilirsin.",
  },
  {
    icon: <FaMoneyCheckAlt size={32} className="text-green-500" />,
    title: "1 Günde Hızlı Ödemeni Al",
    description:
      "Teklifimizi iletelim, aklına yatıyorsa 1 günde hesabına yatsın.",
  },
];

const FeatureCards = () => {
  return (
    <div className="bg-black py-8">
    <div className="px-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {features.map((feature, index) => (
          <div
            key={index}
            className="border border-gray-500 rounded-lg p-6 text-center text-white hover:border-white transition duration-300"
          >
            <div className="mb-4 flex justify-center">{feature.icon}</div>
            <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
            <p className="text-sm">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  </div>

  );
};

export default FeatureCards;
